export default function Select(props: {
  onChange: (value: string) => void;
  value: string;
  options: { key: string; label: string; disabled?: boolean }[];
  placeholder?: string;
  id?: string;
  className?: string;
}) {
  return (
    <select
      id={props.id}
      required
      onChange={(event) => {
        props.onChange(event.target.value);
      }}
      value={props.value}
      className={`rounded-md focus:border-purple-500 border-gray-300  text-base font-medium text-slate-700 text-left shadow-sm focus:outline-none  focus:ring-purple-500 sm:text-sm ${
        props.className ? props.className : ""
      }`}
    >
      {props.placeholder && (
        <option value="" disabled>
          {props.placeholder}
        </option>
      )}
      {props.options.map((option) => (
        <option
          key={"option" + option.key}
          value={option.key}
          disabled={option.disabled}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
}
